function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Circle, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Circle, {
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M10.302 11.029a6.848 6.848 0 00-2.008 5.105 6.934 6.934 0 002.035 4.695c2.719 2.712 7.102 2.725 9.803.024a6.866 6.866 0 002.014-4.664c.194-6.239-7.42-9.579-11.844-5.159zm10.566 5.118a5.581 5.581 0 01-1.61 3.738l-.026.023c-2.207 2.213-5.806 2.203-8.029-.023a5.69 5.69 0 01-1.668-4.012 5.608 5.608 0 011.617-3.97l.023-.025c3.555-3.566 9.678-.984 9.7 4.035 0 .078 0 .156-.007.234z",
  fill: "#7057FF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#7057FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.84,
  d: "M12.9 15.65h4.9"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#7057FF",
  strokeLinecap: "round",
  strokeWidth: 1.4,
  d: "M20.214 20.464l6.336 4.986"
}));

function SvgIconZoomLess(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35
  }, props), _ref);
}

export default SvgIconZoomLess;